import type { PaymentRequest } from '@stripe/stripe-js';

import type { Currency } from '../types';

export enum PAYMENT_METHOD_TYPE {
  NATIVE = 'NATIVE',
  STRIPE = 'STRIPE',
  SAVED_CARD_STRIPE = 'SAVED_CARD_STRIPE',
  PAYPAL = 'PAYPAL',
  SAVED_PAYPAL = 'SAVED_PAYPAL',
  VOUCHER = 'VOUCHER',
}

export enum CURRENCY_SYMBOL {
  GBP = '£',
  EUR = '€',
}

export type TCardType = 'VISA' | 'MASTERCARD' | 'AMEX';

export type NativePayment = 'GOOGLE' | 'APPLE';

export interface CanMakePayment {
  paymentRequest: PaymentRequest;
  type: NativePayment | null;
}

export interface PaymentProduct {
  name: string;
  description: string;
  price: string;
}

export interface PaymentMethod {
  id: string | null;
  name?: string;
  url: string;
  type: PAYMENT_METHOD_TYPE;
  selected: boolean;
  surcharge: string;
  icon: string | null;
  display: string;
}

export interface CardPaymentMethod {
  type: TCardType;
  displayCardNumber: string;
  lastFourDigits: string;
  paymentMethodId: string;
  icon: string | null;
  isDefault: boolean;
}

export interface OrderPayment {
  methods: PaymentMethod[];
  products: PaymentProduct[];
  displayPrice: string;
  total: number;
  currency: Currency;
  defaultCard: CardPaymentMethod[];
}

export type TPaymentIntentStatus =
  | 'canceled'
  | 'processing'
  | 'requires_action'
  | 'requires_capture'
  | 'requires_confirmation'
  | 'requires_payment_method'
  | 'succeeded';

export const PAYMENT_ERROR_TYPE = {
  CLIENT_ERROR: 'ClientError',
  SERVER_ERROR: 'ServerError',
  UNKNOWN_ERROR: 'UnknownError',
} as const;

export type PaymentErrorType =
  (typeof PAYMENT_ERROR_TYPE)[keyof typeof PAYMENT_ERROR_TYPE];

export interface Payment {
  clientSecret: string;
  status?: TPaymentIntentStatus;
}

export interface PaymentError {
  message: string;
  type: PaymentErrorType;
}
